import React from 'react';
type BadgeVariant = 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info';
type BadgeSize = 'sm' | 'md' | 'lg';
interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  size?: BadgeSize;
  className?: string;
  withDot?: boolean;
}
export function Badge({
  children,
  variant = 'default',
  size = 'md',
  className = '',
  withDot = false
}: BadgeProps) {
  const variantStyles: Record<BadgeVariant, string> = {
    default: 'bg-gray-700 text-gray-300 border-gray-600',
    primary: 'bg-blue-900/30 text-blue-300 border-blue-800',
    success: 'bg-green-900/30 text-green-300 border-green-800',
    warning: 'bg-yellow-900/30 text-yellow-300 border-yellow-800',
    danger: 'bg-red-900/30 text-red-300 border-red-800',
    info: 'bg-indigo-900/30 text-indigo-300 border-indigo-800'
  };
  const sizeStyles: Record<BadgeSize, string> = {
    sm: 'text-xs px-1.5 py-0.5',
    md: 'text-xs px-2 py-1',
    lg: 'text-sm px-2.5 py-1'
  };
  const dotColors: Record<BadgeVariant, string> = {
    default: 'bg-gray-400',
    primary: 'bg-blue-400',
    success: 'bg-green-400',
    warning: 'bg-yellow-400',
    danger: 'bg-red-400',
    info: 'bg-indigo-400'
  };
  return <span className={`inline-flex items-center rounded-full border ${variantStyles[variant]} ${sizeStyles[size]} font-medium ${className}`} data-id="element-765">
      {withDot && <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${dotColors[variant]}`} data-id="element-766"></span>}
      {children}
    </span>;
}